/* eslint-disable prettier/prettier */
<template>
  <section class="section no-padding-mobile">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <h4 class="title is-4 is-hidden-mobile">
      <a @click="$router.go(-1)"> <b-icon icon="arrow-left" /> Volver </a>
    </h4>
    <b-tabs
      v-model="activeTab"
      @input="tabClick"
      position="is-centered"
      type="is-toggle"
      size="is-small"
    >
      <b-tab-item icon-pack="fas" icon="info-circle" :label="$t('Detalles')">
        <not-included-in-plan v-if="isDataFormDisabled" />
        <request-data-form v-else :id="id" />
      </b-tab-item>
      <b-tab-item icon-pack="fas" icon="stream" :label="$t('Timeline')">
        <request-timeline
          @newMessage="submitNewMessage"
          @deleteMessage="deleteMessage"
          @updateRequestStatus="updateRequest"
          :requestData="requestData"
          :events="timelineEvents"
        />
      </b-tab-item>
      <b-tab-item icon-pack="fas" icon="file" :label="$t('Archivos')">
        <request-files @deleteFile="deleteFile" :files="requestFiles" />
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'
import NotIncludedInPlan from '@/components/common/NotIncludedInPlan'
import RequestTimeline from '@/components/on-board/RequestTimeline'
import RequestFiles from '@/components/on-board/RequestFiles'
import RequestDataForm from '@/components/forms/RequestDataForm'
import Pusher from 'pusher-js'

export default {
  data() {
    return {
      activeTab: 0,
      timelineEvents: [],
      requestFiles: [],
      requestData: {
        status: null,
        email: null,
        phase: null,
        updatedAt: null
      }
    }
  },
  props: ['id'],
  mixins: [Fetcher],
  components: {
    RequestTimeline,
    RequestDataForm,
    NotIncludedInPlan,
    RequestFiles
  },
  computed: {
    ...mapState('user', [
      'userName',
      'rol',
      'userEmail',
      'subscription',
      'expirationDate'
    ]),
    isDataFormDisabled() {
      return this.rol == 'partner' && this.rol == 'trial'
    }
  },
  mounted() {
    let self = this
    self.loadRequestData()
    let pusher = new Pusher('936ddb2d71afd002b5d0', {
      cluster: 'eu',
      forceTLS: true
    })

    let channel = pusher.subscribe(self.id)
    channel.bind('timeline-event', function(newEvent) {
      self.timelineEvents.push({
        eventType: newEvent.SK.split('|')[0],
        timestamp: newEvent.timestamp,
        source: newEvent.GSI1SK.split('|')[0],
        content: newEvent.content,
        link: newEvent.link,
        title: newEvent.title
      })
    })
  },
  methods: {
    ...mapActions('onBoard', [
      'getOnboardRequestTimelineEvents',
      'getOnboardRequestDetails',
      'putUpdateOnboardRequest',
      'postNewOnboardRequestMessage',
      'getOnboardRequestFiles',
      'deleteOnboardRequestMessage',
      'deleteOnboardRequestFile'
    ]),
    tabClick(e) {
      this.activeTab = 0
      console.log(e)
    },
    submitNewMessage: function(data) {
      let self = this
      self.request(() =>
        self
          .postNewOnboardRequestMessage({
            data: data,
            requestId: self.id
          })
          .then(function() {
            self.loadRequestData()
          })
      )
    },
    deleteMessage: function(message) {
      let self = this
      self.request(() =>
        self
          .deleteOnboardRequestMessage({
            messageId: message.timestamp,
            requestId: self.id
          })
          .then(function() {
            self.loadRequestData()
          })
      )
    },
    deleteFile: function(file) {
      let self = this
      self.request(() =>
        self
          .deleteOnboardRequestFile({
            fileId: file.created_at,
            requestId: self.id
          })
          .then(function() {
            self.loadRequestData()
          })
      )
    },
    updateRequest: function(data) {
      let self = this
      self.request(() =>
        self
          .putUpdateOnboardRequest({
            data,
            requestId: self.id
          })
          .then(function() {
            self.loadRequestData()
          })
      )
    },
    loadRequestData: function() {
      let self = this
      self.request(() =>
        self.getOnboardRequestDetails(self.id).then(function(response) {
          self.requestData = response.data
        })
      )
      self.request(() =>
        self.getOnboardRequestFiles(self.id).then(function(response) {
          self.requestFiles = response.data
        })
      )
      self.request(() =>
        self.getOnboardRequestTimelineEvents(self.id).then(function(response) {
          const timelineEvents = response.data.map(function(elem) {
            return {
              eventType: elem.SK.split('|')[1],
              timestamp: elem.timestamp,
              source: elem.GSI1SK.split('|')[0],
              content: elem.content,
              link: elem.link,
              title: elem.title
            }
          })
          self.timelineEvents = timelineEvents
        })
      )
    }
  }
}
</script>

<style scoped></style>
